export const SENDING_REQUEST = 'TREETEMPLATESFORM_SENDING_REQUEST';
export const GET_TREE_SUCCESS = 'TREETEMPLATESFORM_GET_TREE_SUCCESS';
export const FAILURE = 'TREETEMPLATESFORM_FAILURE';